import { Box, Grid, Typography, TextField } from "@mui/material";
import RootComponents from "../../../components/common/RootComponents";
import { customTextColor } from "../../../utils/const";
import styles from "../../PostSearch/PostRequirement.module.css";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import { useEffect, useState } from "react";
import { PiFileTextLight } from "react-icons/pi";
import { PiFilesLight } from "react-icons/pi";
import { useLocation, useNavigate } from "react-router-dom";
import { IoIosArrowRoundBack } from "react-icons/io";
import { allLocation } from "../../../redux/common/locationSlice";
import { useDispatch, useSelector } from "react-redux";

const CandidateView = () => {
  const [isAddingNote, setIsAddingNote] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const locations = useSelector((state) => state.location);
  const workautho = useSelector((state) => state.workautho);
  const { res } = location.state || {};
  const { row } = location.state || {};
  const { type } = location.state || {};

  const handleAddNote = () => {
    setIsAddingNote(true);
  };

  const handleSendNow = () => {
    // Handle the action for sending the note
  };

  const handleBack = () => {
    setIsAddingNote(false);
  };

  useEffect(() => {
    dispatch(allLocation());
  }, []);

  const getLocationById = (id) => {
    let locationResult = locations?.data?.locations?.find(
      (res) => res.id === id
    );
    return locationResult?.name;
  };

  const getWorkAuthorization = (id) => {
    let authorizationResult = workautho?.data?.work_authorization_data?.find(
      (res) => res.id === id
    );
    return authorizationResult?.name;
  };

  const handleOnClickBack = () => {
    if (type === "view") {
      navigate("/internal-view", {
        state: { row: row },
      });
    } else {
      navigate("/internal-tracker-submissions", {
        state: { row: row, type: "added" },
      });
    }
  };

  return (
    // <RootComponents>
    <Box className={styles.candidate_structure}>
      {res?.prefer_tax_team === "contract" && (
        <Box className={styles.consultant_details}>
          <span>
            <Typography sx={{ marginBottom: "15px !important" }}>
              <b>Response from Bench Sale Recruiter</b>
            </Typography>
            <Typography>
              Name: <b> {res?.employer_manager_name} </b>
            </Typography>
            <Typography>
              Phone No: <b> {res?.employer_mobile_no}</b>
            </Typography>
            <Typography>
              E-Mail ID:
              <b> {res?.employer_email}</b>
            </Typography>
          </span>
        </Box>
      )}

      <Grid
        container
        className={styles.profile_details_view}
        sx={{ color: customTextColor, margiTop: "10px" }}
      >
        <Grid
          item
          md={6}
          lg={6}
          sx={{ display: "block !important" }}
          className={styles.profile_details_views}
        >
          <ul style={{ listStyleType: "square", padding: "20px" }}>
            <Box>
              <li>
                <Typography>
                Candidate Name: <b>{res?.full_name} </b>
                </Typography>
              </li>
            </Box>
            <Box>
              <li>
                <Typography>
                  Phone No:
                  <b> {res?.mobile_no} </b>
                </Typography>
              </li>
            </Box>

            {/* <Box>
                <li>
                  <Typography>
                    Gender:
                    <b> {res?.gender} </b>
                  </Typography>
                </li>
              </Box> */}
            <Box>
              <li>
                <Typography>
                  Location: <b>{getLocationById(res?.current_location)}</b>
                </Typography>
              </li>
            </Box>
            <Box>
              <li>
                <Typography>
                  Billing:
                  <b> {res?.rate}</b>
                </Typography>
              </li>
            </Box>
            <Box>
              <li>
                <Typography>
                  Work Authorization:
                  <b> {getWorkAuthorization(res?.work_authorization)}</b>
                </Typography>
              </li>
            </Box>
          </ul>
        </Grid>

        <Grid
          item
          md={6}
          lg={6}
          sx={{ display: "block !important" }}
          className={styles.profile_details_views}
        >
          <ul style={{ listStyleType: "square" }}>
            <Box>
              <li>
                <Typography>
                  Job Profile: <b> {res?.current_job_title}</b>
                </Typography>
              </li>
            </Box>
            <Box>
              <li>
                <Typography>
                  Experience:<b> {res?.total_experience} </b>
                </Typography>
              </li>
            </Box>

            <Box>
              <li>
                <Typography>
                  Job Type:<b> {res?.prefer_tax_team} </b>
                </Typography>
              </li>
            </Box>

            <Box>
              <li>
                <Typography>
                  E-Mail ID: <b> {res?.email} </b>
                </Typography>
              </li>
            </Box>

            <Box sx={{ marginBottom: "0 !important" }}>
              <li>
                <Typography>
                  <b>Open Resume</b>
                  <span
                    style={{
                      backgroundColor: "#e1eaf0",
                      borderRadius: "3px",
                      marginLeft: "10px",
                      padding: "5.5px",
                    }}
                  >
                    <PiFileTextLight style={{ fontSize: "20px" }} />
                  </span>
                </Typography>
              </li>
            </Box>
          </ul>
        </Grid>
      </Grid>

      <Box className={styles.send_update_btns}>
        {isAddingNote ? (
          <button onClick={handleSendNow}>Send Now</button>
        ) : (
          <Box className={styles.back_btns}>
            <button
              onClick={handleOnClickBack}
              style={{
                border: "1.5px solid #4285f4",
                marginRight: "10px",
                padding: "4.5px 10px ",
                backgroundColor: "#f0f2f5",
              }}
            >
              <IoIosArrowRoundBack
                style={{ fontSize: "25px", color: "#4285f4" }}
              />
            </button>
          </Box>
        )}

        {isAddingNote && (
          <Box className={styles.action_update_btns}>
            <button style={{ backgroundColor: "#3856a6" }}>Action</button>
          </Box>
        )}
      </Box>
    </Box>
    // </RootComponents>
  );
};

export default CandidateView;
